'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { colorMap } from '../../utils';
import { PlaceholderItem, StyledIcon, StyledItem, Title, Value, ValuePrimary, Wrapper } from './ADataItem.styles';
export const ADataItem = ({ className, color, hasDottedLine, hasTopLine, icon, iconColor, isBold, isInBoldList, isLoading, textColor, title, topLineColor, value })=>{
    if (isLoading) {
        return /*#__PURE__*/ _jsx(PlaceholderItem, {
            className: className
        });
    }
    return /*#__PURE__*/ _jsxs(StyledItem, {
        $hasTopLine: hasTopLine,
        $topLineColor: topLineColor && colorMap[topLineColor],
        className: className,
        children: [
            icon && /*#__PURE__*/ _jsx(StyledIcon, {
                $color: iconColor,
                name: icon
            }),
            /*#__PURE__*/ _jsxs(Wrapper, {
                $hasDottedLine: hasDottedLine ?? false,
                $textColor: color ? colorMap[color] : textColor && colorMap[textColor],
                children: [
                    /*#__PURE__*/ _jsx(Title, {
                        bold: isInBoldList || isBold,
                        size: "xs",
                        children: title
                    }),
                    hasTopLine ? /*#__PURE__*/ _jsx(ValuePrimary, {
                        bold: isBold,
                        size: "xs",
                        children: value
                    }) : /*#__PURE__*/ _jsx(Value, {
                        bold: isBold,
                        size: "xs",
                        children: value
                    })
                ]
            })
        ]
    });
};

//# sourceMappingURL=ADataItem.js.map